import { MdClose } from 'react-icons/md'
import { Modal, Wrapper, ButtonsSend, TextAnnotation } from './styles'

interface TitleProps {
  item: any
  name: string
  setStep(step: number | string): void
}

const SeeNote: React.FC<TitleProps> = ({ item, name, setStep }) => {
  return (
    <Modal>
      <Wrapper>
        <div>
          <h1>Anotações deste capítulo</h1>
          <h2>Capítulo {name}</h2>
        </div>
        <button id="close" onClick={() => setStep(0)}>
          <MdClose id="close" size={20} />
        </button>
      </Wrapper>
      <TextAnnotation>
        <h2>{item.highlight?.text}</h2>
        <p>{item.note}</p>
      </TextAnnotation>
      <ButtonsSend>
        <button type="submit" className="back-button" id="close" onClick={() => setStep(0)}>
          Voltar
        </button>
      </ButtonsSend>
    </Modal>
  )
}

export default SeeNote
